import React from "react";
import {
  Loader,
  DepositForm,
  PageLayout,
  AlfredIneligibleBlocker,
  AlfredKycFallbackForm,
} from "src/components";
import { useDepositWithdrawContext } from "src/contexts";
import { useAlfredKycFallbackGate } from "src/hooks";
import "./deposit.scss";

const DepositPage: React.FC = (): JSX.Element => {
  const { widgetDataLoading, widgetDataError, alfredIneligibilityCode } =
    useDepositWithdrawContext();
  const { alfredKycFallback, loading: kycFallbackLoading } =
    useAlfredKycFallbackGate(alfredIneligibilityCode);

  // Resolve the active screen + a stable key. The key drives the wrapper's
  // remount so every screen swap fades in uniformly (not just the Alfred ones).
  let screen: JSX.Element;
  let screenKey: string;
  if (widgetDataLoading || widgetDataError || kycFallbackLoading) {
    screen = <Loader />;
    screenKey = "loading";
  } else if (alfredKycFallback) {
    screen = <AlfredKycFallbackForm fallback={alfredKycFallback} />;
    screenKey = "kyc-fallback";
  } else if (alfredIneligibilityCode) {
    screen = <AlfredIneligibleBlocker code={alfredIneligibilityCode} />;
    screenKey = "ineligible";
  } else {
    screen = (
      <PageLayout>
        <DepositForm />
      </PageLayout>
    );
    screenKey = "form";
  }

  return (
    <div key={screenKey} className="deposit-screen">
      {screen}
    </div>
  );
};

export default DepositPage;
